module.exports = __webpack_public_path__ + "static/media/NotasFiscais2.de35052b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancNotasFiscais/NotasFiscais2.png
// module id = 2132
// module chunks = 0